import React from "react";
import { allModelsState, setCurrentIframeLink } from "./reduxSlice";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { AiOutlineArrowRight } from "react-icons/ai";
import "./App.css";
import wavetwo from "../../assets/svg/wave.svg";
import { Container } from "react-bootstrap";

function AllThreeDModels() {
  const { modalsPreview, currentIframeLink } = useSelector(allModelsState);
  const dispatch = useDispatch();

  return (
    <>
      <div className="productTitle">
        <h1>
          Products<span>explore amongs the best</span>
        </h1>
      </div>
      <Container>
        <div className="row col-xl-10 col-md-12 mb-4 d-flex mx-auto ">
          {modalsPreview.map((products, index) => {
            return (
              <>
                <div className="col-sm-4 col-6 g-4 d-flex justify-content-center align-items-center">
                <Link
                to={`/product/${index}`}
                style={{
                  textDecoration: "none",
                  color: "black",
                  textAlign: "center",
                
                }}>
                  <div className="card border-0">
                    <div className="product-title px-2">
                        <div className="product-name">
                        <span className="product-name">{products.title}</span>
                        </div>
                        <div className=" product-arrow">
                        <span className="product-name">
                          <AiOutlineArrowRight style={{ color: "#9b9b9b" }} />
                        </span>
                        </div>
                    </div>
                   <div className="product-img">
                   <img
                    className="products-img shadow  "
                    src={products.img}
                    alt="threeDimage"
                  />
                   </div>
                    <div className="p-md-4">
                    <div className="info">
                    <span style={{ color: "balack", fontSize: "22px", fontWaight: "400" }}>{products.title}</span>
                    <p>
                      Lorem Ipsum is simply dummy text from the printing and
                      typeseting industry
                    </p>
                    <div className="info-bottom">
                    <div className="info-btn">
                    <button>Open Now</button>
                    </div>
                      <div className="scrollDownTwo ml-xl-5 ml-md-3">
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                    </div>
                    </div>
                    </div>
                  </div>
                  </Link>
                </div>
              </>
            );
          })}
        </div>
      </Container>
    </>
  );
}

export default AllThreeDModels;